module.exports = __webpack_public_path__ + "static/media/old-bridge.72d68dfd.svg";